function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback } from 'react';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/folders/{id}/user_access_folder_participations', {
  only: ['create', 'update', 'delete']
});
const useDeleteUserAccessFolderParticipationFromClaimGroup = (claimGroup, setClaimGroup, setLoading) => {
  const deleteParticipation = serviceMethods.useDelete({
    callback: useCallback(async (selectedUserAccess, participation, folderId) => {
      await api.delete(folderId, participation.id);
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_folder_participations = userAccessInClaimGroup.user_access_folder_participations.filter(existingParticipation => existingParticipation.id !== participation.id);
      setClaimGroup(_objectSpread({}, claimGroup));
    }, [claimGroup, setClaimGroup]),
    setLoading
  });
  return deleteParticipation;
};
const useCreateUserAccessFolderParticipationFromClaimGroup = (claimGroup, setClaimGroup, setLoading) => {
  const createParticipation = serviceMethods.useCreate({
    callback: useCallback(async (selectedUserAccess, folderId) => {
      const newParticipation = await api.create(folderId, {
        user_access_id: selectedUserAccess.id
      });
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_folder_participations || (userAccessInClaimGroup.user_access_folder_participations = []);
      userAccessInClaimGroup.user_access_folder_participations.push(newParticipation);
      setClaimGroup(_objectSpread({}, claimGroup));
      return newParticipation;
    }, [claimGroup, setClaimGroup]),
    setLoading
  });
  return createParticipation;
};
const useUpdate = (claimGroup, setClaimGroup) => {
  const update = serviceMethods.useUpdate({
    callback: useCallback(async _ref => {
      let {
        user_access_folder_participation
      } = _ref;
      const updated = await api.update(user_access_folder_participation.folder_id, user_access_folder_participation.id, {
        user_access_folder_participation
      });
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === updated.user_access_id);
      const index = userAccessInClaimGroup.user_access_folder_participations.findIndex(participation => participation.id === updated.id);
      userAccessInClaimGroup.user_access_folder_participations[index] = updated;
      setClaimGroup(_objectSpread({}, claimGroup));
      return updated;
    }, [claimGroup, setClaimGroup])
  });
  return update;
};
const userAccessFolderParticipationsService = {
  useDeleteUserAccessFolderParticipationFromClaimGroup,
  useCreateUserAccessFolderParticipationFromClaimGroup,
  useUpdate
};
export default userAccessFolderParticipationsService;